import { render, staticRenderFns } from "./WatchVideoButton.vue?vue&type=template&id=0c4ef161&scoped=true"
import script from "./WatchVideoButton.vue?vue&type=script&lang=js"
export * from "./WatchVideoButton.vue?vue&type=script&lang=js"
import style0 from "./WatchVideoButton.vue?vue&type=style&index=0&id=0c4ef161&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ef161",
  null
  
)

export default component.exports